import * as React from "react";
import Image from "next/image";

const LogoImageContainer = ({
  src,
  alt = "Logo",
  width = 62,
  height = 74,
  ...props
}) => {
  // Calculate center position of the white circle area
  const circleCenter = {
    x: 32.406 + 108.269 / 2, // 86.5405
    y: 32.688 + 108.269 / 2, // 86.8225
  };

  // Calculate foreignObject position to center the image
  const foreignObjectX = circleCenter.x - width / 2;
  const foreignObjectY = circleCenter.y - height / 2;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={173}
      height={173}
      fill="none"
      {...props}
    >
      <rect
        width={147.639}
        height={147.639}
        x={12.723}
        y={13}
        fill="#F8FAFF"
        rx={73.82}
      />
      <rect
        width={147.639}
        height={147.639}
        x={12.723}
        y={13}
        stroke="#F8FAFF"
        strokeOpacity={0.6}
        strokeWidth={24.607}
        rx={73.82}
      />
      <rect
        width={108.269}
        height={108.269}
        x={32.406}
        y={32.688}
        fill="#fff"
        rx={54.134}
      />
      <foreignObject
        x={foreignObjectX}
        y={foreignObjectY}
        width={width}
        height={height}
      >
        <img
          src={src}
          alt={alt}
          width={width}
          height={height}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </foreignObject>
    </svg>
  );
};

export default LogoImageContainer;
